import { render } from "./PersonsDashboard.vue?vue&type=template&id=77be05bc&scoped=true"
import script from "./PersonsDashboard.vue?vue&type=script&lang=js"
export * from "./PersonsDashboard.vue?vue&type=script&lang=js"

import "./PersonsDashboard.vue?vue&type=style&index=0&id=77be05bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77be05bc"]])

export default __exports__